import React from 'react';
import axios from 'axios';

import { useModal } from '../Components/Modal/ModalContext';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import LoadingLines from '../Components/LoadingLines';

import HeaderPanel from '../Components/HeaderPanel';

const Applications = () => {
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();

    const token = localStorage.getItem('token');
    React.useEffect(() => {
        axios.get('/api/cases-for-application', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            if (response.data.length === 0) {
                setWarning('В данный момент заявки отсутствуют.');
            } else {
                setWarning('');
                setCases(response.data);
            }
        })
        .catch(error => {
            setWarning(`Ошибка загрузки таблицы заявок: ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        })
    }, [reload]);

    const formatComment = (comment) => {
        if (comment === 'Заметка отсутствует') {
            return <span style={{color: 'rgb(169, 169, 169)'}}>{comment}</span>
        }else {
            return <span>{comment}</span>;
        }
    };
    const formatFile = (file) => {
        if (!file) {
            return <span style={{color: 'rgb(169, 169, 169)'}}>Файл не прикреплен</span>
        }else {
            return <span>{file}</span>;
        }
    };

    const claimACase = (caseId) => {
        axios.put(`/api/claim-a-case?caseId=${caseId}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setReload(true);
            if(response.data.status=='Претендует') {
                openTimeModal('Заявка зарегистрирована в системе. После проведения собрания СОАУ Альянс проинформирует вас о решении', 'success');
            } else {
                openTimeModal('Заявка на ведение отозвана', 'success');
            }
        })
        .catch(error => {
            openTimeModal('Ошибка записи аккаунта в таблицу', 'error');
            console.error('Ошибка при получении данных:', error)
        });
    };


    return (
        <div className="mainContainer">
            <h1>Заявки</h1>
            <HeaderPanel typePanel='Арбитражный управляющий' />
            {/* <div className={headerPanel.additionalPanel}>
                <input type='text' placeholder='Поиск по номеру...' />
            </div> */}
            <div className='tableHeader'>
                <a style={{width: '20%'}}>Номер дела</a>
                <a style={{width: '20%'}}>Истец</a>
                <a style={{width: '20%'}}>Комментарий</a>
                <a style={{width: '20%'}}>Файл</a>
                <a style={{width: '20%'}}>Действие</a>
            </div>
            {loading && <LoadingLines />}
            {warning && <div className='case warningLine'><a>{warning}</a></div>}
            {cases.map((cases) => (
                <div className='user' key={cases.id}>
                    <a style={{width: '20%'}}>{cases.number}</a>
                    <a style={{width: '20%'}}>{cases.applicant}</a>
                    <a style={{width: '20%'}}>{formatComment(cases.comments)}</a>
                    {/* <a style={{width: '20%'}}>{formatFile(cases.file) || 'Ошибка системы'}</a> */}
                    <a style={{width: '20%'}}>Файл указан в письме</a>
                    {cases.statusApplication == 'Претендует' ? 
                        <a style={{width: '20%', borderRight: 'none'}}><button className='button maxWidth' onClick={() => {claimACase(cases.id)}}>Отменить</button></a>
                        :
                        <a style={{width: '20%', borderRight: 'none'}}><button className='button' onClick={() => {claimACase(cases.id)}}>Претендовать на ведение дела</button></a>
                    }
                </div>
            ))}
        </div>
    )
}

export default Applications;